import { render, staticRenderFns } from "./workersreportChange.vue?vue&type=template&id=1394f4aa&"
import script from "./workersreportChange.vue?vue&type=script&lang=js&"
export * from "./workersreportChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports